export function resolveApiBaseUrl(configured) {
  const value = typeof configured === 'string' ? configured.trim() : '';
  return value ? value.replace(/\/$/, '') : '/api';
}

export const API_BASE_URL = resolveApiBaseUrl(process.env.REACT_APP_API_URL);
